import { useLanguage } from "@/lib/i18n";
import { blogScanContent } from "./content";

export function BlogScanWhichApp() {
  const { language } = useLanguage();
  const c = blogScanContent[language].whichApp;

  return (
    <section className="mx-auto max-w-[680px] px-4 sm:px-6 py-6">
      <h2 className="font-['Source_Serif_4'] text-2xl md:text-3xl font-semibold text-foreground mt-12 mb-5">
        {c.title}
      </h2>

      <p className="font-['Source_Serif_4'] text-base md:text-lg leading-[1.8] text-foreground/85 mb-5">
        {c.p1}
      </p>

      <p className="font-['Source_Serif_4'] text-base md:text-lg leading-[1.8] text-foreground/85 mb-5">
        {c.p2}
      </p>

      <p className="font-['Source_Serif_4'] text-base md:text-lg leading-[1.8] text-foreground/85 mb-5">
        {c.p3}
      </p>
    </section>
  );
}
